import React from 'react'

const CarouselCard = (props) => {
	return (
		<div className='card-content'>
			<img
				src={props.img}
				alt={props.title}
				style={{
					width: '100%',
					objectFit: 'cover',
				}}
			/>
			<div
				style={{
					position: 'absolute',
					padding: '65px 28px 0',
					width: '380px',
					height: '524px',
					background: 'rgba(0, 0, 0, .7)',
				}}
			>
				<h2 className='card-title'>{props.title}</h2>
				<p className='card-details'>{props.details}</p>
			</div>
		</div>
	)
}

export default CarouselCard



// WEBPACK FOOTER //
// ./src/containers/AboutPage/Maxims/CarouselCard.js